import { render, staticRenderFns } from "./NoticeIcon.vue?vue&type=template&id=ac7dba8e&scoped=true"
import script from "./NoticeIcon.vue?vue&type=script&lang=js"
export * from "./NoticeIcon.vue?vue&type=script&lang=js"
import style0 from "./NoticeIcon.vue?vue&type=style&index=0&id=ac7dba8e&prod&lang=css"
import style1 from "./NoticeIcon.vue?vue&type=style&index=1&id=ac7dba8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7dba8e",
  null
  
)

export default component.exports